import React, { useState } from "react";
import { Row, Col, Alert } from "components/common";
import TableView from "./table/TableView";
import AddModal from './add/AddModal'
import EditModal from './edit/EditModal'
import { Wrapper } from "./ShareCartPage.styled";

export default function ShareCartPage() {
  const [shouldLoad, setShouldLoad] = useState(true)
  const [modalMode, setModalMode] = useState(undefined)
  const [selected, setSelected] = useState(undefined)

  return (
    <Wrapper>
      <Row gutter={[20, 20]}>
        <Col xs={24}>
          <Alert type="info" style={{ alignItems: "baseline" }} message={<div dangerouslySetInnerHTML={{ __html: `In order to share a pre-filled cart with your prospects, simply click create cart, add which products you'd like to feature, and select the subscription frequency. Once you have added a shareable cart, you can share the URL with your prospects and our system will track your sales. For questions, please email <a style="color: #1890ff; text-decoration: none" href="mailto:support@nuevalife.com">support@nuevalife.com</a>.`}} />} showIcon />
        </Col>
      </Row>
      <TableView 
        shouldLoad={shouldLoad}
        setShouldLoad={setShouldLoad}
        setModalMode={setModalMode}
        setSelected={setSelected}
      />
      {modalMode==='add' && 
        <AddModal
          setModalMode={setModalMode}
          setShouldLoad={setShouldLoad}
        />
      }
      {(modalMode==='edit' && selected) &&
        <EditModal setModalMode={setModalMode}
          selected={selected}
          setShouldLoad={setShouldLoad}
        />
      }
    </Wrapper>
  );
}
